import React, { useRef } from 'react';
import { Button, Row } from 'reactstrap';
import { faArrowLeft, faFileCsv, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSVLink } from 'react-csv';

//Context
import { useAuth } from '../../../../context/auth';
import moment from 'moment';
import CardRelatorio from '../components/CardRelatorio';
import { useReactToPrint } from 'react-to-print';

//Estilo da pagina de impressão
const pageStyle = `
@media print {
  @page{
    size: A4;
    margin: 0.5rem;
  }

  body { 
    -webkit-print-color-adjust: exact; 
  } 

  .relatorio {
    width: 100vw !important;
    display:flex !important;
    flex-direction: column !important;
    padding: 0px 15px !important;
  }

  div.header{
    display:table-header-group;
  }

  div.body{
    display:table-row-group;
  }

  .noPrint{
    display: none;
  }
}
`;

function RelatorioGerenciamentoArrecadacao({ listaArrecadacao = [], filtros, handleVoltar }) {
  const { session, logoSistema, logoSecretaria, logoPrefeitura } = useAuth();

  //Referencia do relatorio para download do csv
  const exportRef = useRef(null);

  //Referencia para o componente de impressão
  const ref = useRef(null);

  //headers da exportação do csv
  const headersExport = [
    { key: "nomeInfrator", label: "NOME INFRATOR" },
    { key: "numeroInfracao", label: "NÚMERO DA INFRAÇÃO" },
    { key: "numeroProcesso", label: "PROCESSO" },
    { key: "documentoInfrator", label: "CNPJ DO INFRATOR" },
    { key: "infracao_Identificacao", label: "IDENTIFICAÇÃO DA INFRAÇÃO" },
    { key: "numeroGuia", label: " NÚMERO DA GUIA" },
    { key: "statusBoleto", label: " STATUS DO BOLETO" },
    { key: "valorMulta", label: "VALOR DA MULTA" },
    { key: "dataEmissao", label: "DATA DE EMISSÃO" },
    { key: "dataVencimento", label: "DATA DO VENCIMENTO" },
    { key: "dataPagamento", label: "DATA DO PAGAMENTO" }
  ];

  const headersArrecadacao = [
    { objectValue: "nomeInfrator", value: "Nome Infrator", col: "6" },
    { objectValue: "numeroInfracao", value: "Número da Infração", col: "6" },
    { objectValue: "numeroProcesso", value: "Processo", col: "6" },
    { objectValue: "documentoInfrator", value: "CNPJ do Infrator", col: "6" },
    { objectValue: "infracao_Identificacao", value: "Identificação da Infração", col: "12" },
    { objectValue: "numeroGuia", value: " Número da Guia", col: "4" },
    { objectValue: "statusBoleto", value: " Status do Boleto", col: "4" },
    { objectValue: "valorMulta", value: "Valor da Multa", col: "4" },
    { objectValue: "dataEmissao", value: "Data de Emissão", col: "4" },
    { objectValue: "dataVencimento", value: "Data de Vencimento", col: "4" },
    { objectValue: "dataPagamento", value: "Data de Pagamento", col: "2" },
  ];

  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => ref.current,
    documentTitle: "Fiscalizacação",
    pageStyle: pageStyle
  });


  return <>
    <div className='shadowFicha mainContainerFicha p-4'>

      <div className='d-flex align-items-center justify-content-between'>
        <Button color='secondary' className='text-white' onClick={handleVoltar}>
          <FontAwesomeIcon icon={faArrowLeft} />
          <span className='px-2'> Voltar </span>
        </Button>
        <div className='d-flex gap-2'>
          <Button color='danger' onClick={handlePrint}>
            <FontAwesomeIcon icon={faFilePdf} /> Imprimir
          </Button>
          <Button color='success' onClick={() => exportRef.current.link.click()}>
            <FontAwesomeIcon icon={faFileCsv} />
            <span className='px-2'> CSV </span>
          </Button>
        </div>
      </div>

      <CSVLink
        separator={";"}
        data={listaArrecadacao}
        headers={headersExport}
        filename="Relatorio de Gerenciamento de Arrecadações.csv"
        target="_blank"
        ref={exportRef}
      />

      <div className="mt-4 relatorio w-100" ref={ref}>
        <div className="print m-2 d-flex align-items-center justify-content-between">
          <p>Emitido por: {session.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>

        <div className='d-flex justify-content-between align-items-center w-100'>
          {logoSistema &&
            <div>
              <img src={logoSistema} width={180} alt="logo do sistema" />
            </div>
          }
          <div>
            {logoSecretaria && <img src={logoSecretaria} className='mt-3' width={140} alt="logo do sistema" />}
            {logoSecretaria && <img src={logoPrefeitura} width={120} alt="logo da prefeitura" />}
          </div>
        </div>

        <div className="header">
          <h5 style={{ color: "#666" }}>Relatório Gerenciamento de Arrecadação</h5>
          <Row>
            <div className='col-12'>
              <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
            </div>
            <div className='col-6'>
              <p><span className="fw-bold">Tipo de Busca:</span> {filtros.tipoBusca}</p>
            </div>
            <div className='col-6'>
              <p><span className="fw-bold">Status Boleto:</span> {filtros.statusBoleto}</p>
            </div>
            <div className='col-12'>
              <p><span className="fw-bold">Tipo de Fiscalização:</span> {filtros.tipoFiscalizacao_Descricao}</p>
            </div>
          </Row>
        </div>

        <div
          className='body'
          style={{ color: "#666" }}
        >
          <h5 className='rounded-3 bg-secondary text-light p-2'>Lista de Infrações</h5>
          <CardRelatorio headers={headersArrecadacao} items={listaArrecadacao} />
        </div>
      </div >
    </div>
  </>;
}

export default RelatorioGerenciamentoArrecadacao;